import React from "react";
import { Loading } from "./Loading";
import { Error } from "./Error";
import { Empty } from "./Empty";
import { Box, SxProps } from "@mui/material";

export interface IStateProps {
  loading?: boolean;
  error?: boolean;
  empty?: boolean;
  loadingCopy?: string;
  errorCopy?: string;
  emptyCopy?: string;
  emptyComponent?: React.ReactNode;
  children?: React.ReactNode;
  sx?: SxProps;
  showOverlay?: boolean;
}
export const State: React.FC<IStateProps> = ({
  loading,
  error,
  empty,
  loadingCopy,
  errorCopy,
  emptyCopy,
  emptyComponent,
  children,
  sx,
  showOverlay = false,
}) => {
  const shouldShowOverlay = showOverlay && loading;
  const shouldShowContent = !loading && !error && !empty;
  const shouldShowStateBox = !shouldShowOverlay && (loading || error || empty);

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
      {(shouldShowContent || shouldShowOverlay) && <>{children}</>}

      {shouldShowStateBox && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            minHeight: 300,
            ...sx,
          }}
        >
          {loading ? (
            <Loading copy={loadingCopy} />
          ) : error ? (
            <Error copy={errorCopy} />
          ) : empty ? (
            emptyComponent || <Empty copy={emptyCopy} />
          ) : null}
        </Box>
      )}

      {shouldShowOverlay && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            zIndex: 1000,
          }}
        >
          <Loading copy={loadingCopy} />
        </Box>
      )}
    </Box>
  );
};
